"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _dompurify = _interopRequireDefault(require("dompurify"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 10;\n  top: 0;\n  right: 0;\n  width: 80%;\n  height: 100%;\n  overflow: auto;\n  background: ", ";\n  padding-top: ", "px;\n  transform: translateX(", ");\n  transition: transform 0.35s;\n\n  @media (min-width: ", ") {\n    width: 30%;\n  }\n\n  @media (min-width: ", ") {\n    width: 20%;\n  }\n\n  @media (min-width: ", ") {\n    width: 15%;\n  }\n"])), function (p) {
  return p.theme.colorCardBackground;
}, function (p) {
  return p.theme.topbarPadding;
}, function (props) {
  return props.isOpen ? "0" : "100%";
}, function (props) {
  return props.theme.screenWidthSm;
}, function (props) {
  return props.theme.screenWidthLg;
}, function (props) {
  return props.theme.screenWidthXl;
});

var StyledHeader = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: sticky;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 56px;\n  padding: 0 1rem;\n  font-family: ", ";\n"])), function (p) {
  return p.theme.fontFamilyDefault;
});

var lineHeight = 1.45;

var StyledContent = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: 0 1rem 1rem;\n  font-weight: 400;\n  font-size: 0.875rem;\n  font-family: ", ";\n  line-height: ", ";\n\n  .footer-link {\n    color: inherit;\n    text-decoration: underline;\n    font-size: inherit;\n  }\n\n  h2,\n  h3 {\n    line-height: ", ";\n    margin: 0 0 1rem;\n  }\n\n  h2 {\n    font-size: 1.175rem;\n  }\n\n  h3 {\n    font-size: 1rem;\n  }\n\n  p {\n    line-height: ", ";\n  }\n\n  a {\n    color: ", ";\n    font-size: 0.875rem;\n    line-height: ", ";\n  }\n\n  table {\n    border-collapse: collapse;\n    font-size: 0.75rem;\n  }\n\n  table td,\n  table th {\n    padding: 0.5rem 0.25rem;\n    text-align: left;\n    line-height: ", ";\n    vertical-align: top;\n    border: 1px solid ", ";\n  }\n\n  ul,\n  ol {\n    margin: 0 0 1rem;\n    padding: 0 0 0 1.25rem;\n  }\n\n  ul li,\n  ol li {\n    line-height: ", ";\n    margin-bottom: 0.5rem;\n  }\n"])), function (p) {
  return p.theme.fontFamilyDefault;
}, lineHeight, lineHeight, lineHeight, function (p) {
  return p.theme.colorAccent;
}, lineHeight, lineHeight, function (p) {
  return p.theme.colorBorder;
}, lineHeight);

var instance = _axios.default.create();

var Drawer = function Drawer(_ref) {
  var isOpen = _ref.isOpen,
      useAssetsCdn = _ref.useAssetsCdn,
      pageSlug = _ref.pageSlug,
      pageTitle = _ref.pageTitle,
      onDrawerOpened = _ref.onDrawerOpened,
      onDrawerClosed = _ref.onDrawerClosed,
      onError = _ref.onError;

  var _useState = (0, _react.useState)(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      page = _useState2[0],
      setPage = _useState2[1];

  var getPage = function getPage() {
    if (useAssetsCdn) {
      instance.get("".concat(process.env.REACT_APP_IMAGE_CDN, "pages/").concat(pageSlug, ".html")).then(function (_ref2) {
        var data = _ref2.data;
        setPage({
          content: data,
          title: pageTitle,
          isLegalPage: true
        });
      }).catch(function (_ref3) {
        var response = _ref3.response;
        onError(response);
      });
    } else {
      _axios.default.get("/pages/".concat(pageSlug)).then(function (_ref4) {
        var data = _ref4.data;
        setPage(data === null || data === void 0 ? void 0 : data.data);
      }).catch(function (_ref5) {
        var response = _ref5.response;
        onError(response);
      });
    }
  };

  var pageContent = "";

  if (page !== null && page !== void 0 && page.content && !useAssetsCdn) {
    pageContent = page === null || page === void 0 ? void 0 : page.content.replace("**".concat(page.title, "**\n"), "").replace(/\[[^\s]+\]/g, "").replace(/\(?(https?:(\/\/)?([^\s\)\/]+))(\/?\)?)?/g, "<a href='$1' class='footer-link' target='_blank'>$3</a>").replace(/\(?((mailto:)?([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+))\)?/g, "<a href='$1' class='footer-link'>$3</a>").replace(/\n/gi, "<br />").replace(/↵/gi, "<br />").replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");
  } else {
    pageContent = page === null || page === void 0 ? void 0 : page.content;
  }

  var clean = _dompurify.default.sanitize(pageContent, {
    USE_PROFILES: {
      html: true
    }
  });

  var formattedContent = {
    __html: clean
  };
  (0, _react.useEffect)(function () {
    if (isOpen) {
      getPage();
    } else {
      setPage(undefined);
    }
  }, [isOpen]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledWrapper, {
    isOpen: isOpen
  }, page && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledHeader, {
    onClick: function onClick() {
      return onDrawerClosed();
    }
  }, /*#__PURE__*/_react.default.createElement("span", null, page && pageTitle), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.MatIcon, null, "close")), /*#__PURE__*/_react.default.createElement(StyledContent, {
    dangerouslySetInnerHTML: formattedContent
  })), !page && isOpen && /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.SkeletonTable, null)), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Overlay, {
    isVisible: isOpen,
    zIndex: 9,
    onClick: function onClick() {
      return onDrawerClosed();
    }
  }));
};

var _default = Drawer;
exports.default = _default;